/* MJD collection page: live filters, sort, load more, phone sheet, quick add.
   Everything re-renders through Shopify's section rendering (?section_id=), so
   the markup and filter counts always come from the server. */
(function () {
  function init(root) {
    var id = root.dataset.section;
    var phone = window.matchMedia('(max-width: 900px)');

    function fetchHTML(url) {
      var u = new URL(url, location.origin); u.searchParams.set('section_id', id);
      return fetch(u.toString()).then(function (r) { return r.text(); })
        .then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); });
    }
    function swap(url, push, from) {
      root.classList.add('is-loading');
      /* the filter menu is re-rendered with the results: remember where the shopper was so nothing jumps */
      var y = window.scrollY, menu = root.querySelector('[data-filters]'), menuTop = menu ? menu.scrollTop : 0;
      var focusKey = from && from.name ? [from.name, from.value] : null;
      return fetchHTML(url).then(function (doc) {
        var fresh = doc.querySelector('[data-mjc-results]'), cur = root.querySelector('[data-mjc-results]');
        var open = root.querySelector('[data-filters]').classList.contains('open');
        var collapsed = root.querySelector('[data-layout]').classList.contains('is-collapsed');
        var openGroups = [].map.call(root.querySelectorAll('.mjc-group'), function (d) { return d.open; });
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        var cnt = doc.querySelector('[data-count]'); if (cnt) root.querySelector('[data-count]').textContent = cnt.textContent;
        root.querySelectorAll('.mjc-group').forEach(function (d, i) { if (openGroups[i] !== undefined) d.open = openGroups[i] || d.open; });
        if (open) sheet(true);
        if (collapsed) collapse(true);
        if (push) { var u = new URL(url, location.origin); u.searchParams.delete('section_id'); history.pushState({ mjc: 1 }, '', u.toString()); }
        var m2 = root.querySelector('[data-filters]'); if (m2) m2.scrollTop = menuTop;
        if (focusKey) { var f = [].filter.call(root.querySelectorAll('[data-filters] input'), function (i) { return i.name === focusKey[0] && i.value === focusKey[1]; })[0]; if (f) f.focus({ preventScroll: true }); }
        /* stay put; only if the new results end above this spot (fewer threads), bring the top of the results into view */
        window.scrollTo(0, y);
        var g = root.querySelector('[data-mjc-results]'), r = g.getBoundingClientRect();
        if (r.bottom < window.innerHeight * 0.6) {
          var bar = root.querySelector('.mjc__bar'), hdr = bar ? bar.offsetHeight + parseFloat(getComputedStyle(bar).top || 0) : 0;
          window.scrollTo(0, Math.max(0, r.top + window.scrollY - hdr - 8));
        }
        root.classList.remove('is-loading');
        fill();
      }).catch(function () { location.href = url; });
    }
    function formURL() {
      var form = root.querySelector('[data-filters]'), params = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '' && k !== 'sort_by') params.append(k, v); });
      var sort = root.querySelector('[data-sort]'); if (sort && sort.value) params.set('sort_by', sort.value);
      /* keep an alternate template (?view=) while filtering */
      var view = new URLSearchParams(location.search).get('view'); if (view) params.set('view', view);
      return location.pathname + (params.toString() ? '?' + params.toString() : '');
    }

    var t;
    root.addEventListener('change', function (e) {
      var el = e.target;
      if (el.matches('[data-sort], [data-sort-m]')) {
        root.querySelectorAll('[data-sort], [data-sort-m]').forEach(function (s) { s.value = el.value; });
      }
      if (el.closest('[data-filters]') || el.matches('[data-sort]')) {
        clearTimeout(t); t = setTimeout(function () { swap(formURL(), true, el); }, el.type === 'number' ? 600 : 0);
      }
    });
    root.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-nav]');
      if (nav) {
        e.preventDefault();
        var href = nav.href;
        /* color links change the tag part of the URL; carry over the current filters and sort */
        if (nav.classList.contains('mjc-color')) {
          var u = new URL(href, location.origin), cur = new URLSearchParams(location.search);
          cur.forEach(function (v, k) { if (k !== 'page' && k !== 'section_id' && !u.searchParams.has(k)) u.searchParams.append(k, v); });
          href = u.toString();
        }
        swap(href, true); return;
      }
      var more = e.target.closest('[data-more]');
      if (more) {
        e.preventDefault(); more.textContent = 'Loading…';
        page(more.href).then(function (doc) {
          var grid = root.querySelector('[data-grid]'), seen = shown(grid);
          doc.querySelectorAll('[data-grid] > .mjc-card').forEach(function (c) { if (!seen[key(c)]) grid.appendChild(document.importNode(c, true)); });
          var fm = doc.querySelector('.mjc-more'); if (fm) root.querySelector('.mjc-more').innerHTML = fm.innerHTML;
          count(); fill();
        });
        return;
      }
      if (e.target.closest('[data-filter-toggle]')) { if (phone.matches) sheet(true); else collapse(!root.querySelector('[data-layout]').classList.contains('is-collapsed')); return; }
      if (e.target.closest('[data-close]') || e.target.matches('[data-scrim]')) { sheet(false); return; }
      var q = e.target.closest('[data-quick]');
      if (q) {
        q.disabled = true; q.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +q.dataset.quick, quantity: 1 }] }) })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            q.textContent = j.status ? 'Unavailable' : 'Added';
            if (typeof window.upcartRefreshCart === 'function') { Promise.resolve(window.upcartRefreshCart()).then(function () { if (window.upcartOpenCart) window.upcartOpenCart(); }); }
            setTimeout(function () { q.textContent = 'Quick Add'; q.disabled = false; }, 2200);
          });
      }
    });
    /* Load More: never leave a half-empty last row. Borrow cards from the next page to finish the row;
       the next Load More skips any card that is already showing. */
    var pages = {};
    function page(url) { return pages[url] || (pages[url] = fetchHTML(url)); }
    function key(c) { var a = c.querySelector('a[href]'); return a ? a.getAttribute('href').split('?')[0] : c.textContent; }
    function shown(grid) { var o = {}; grid.querySelectorAll('.mjc-card').forEach(function (c) { o[key(c)] = 1; }); return o; }
    function count() {
      var grid = root.querySelector('[data-grid]'), sp = root.querySelector('[data-shown]'), mt = root.querySelector('[data-meter]');
      if (!grid || !sp) return;
      var n = grid.querySelectorAll('.mjc-card').length, tot = parseInt((root.querySelector('.mjc-more__t') || {}).textContent.replace(/.*of\s*/, ''), 10);
      sp.textContent = n; if (mt && tot) mt.style.width = Math.min(100, n * 100 / tot) + '%';
    }
    function missing(grid) {
      var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length; if (cols < 2) return 0;
      var kids = [].filter.call(grid.children, function (k) { return k.offsetParent; }); if (!kids.length) return 0;
      var bottom = Math.max.apply(null, kids.map(function (k) { return k.offsetTop + k.offsetHeight; }));
      var colW = grid.clientWidth / cols, used = 0, lastTop = Math.max.apply(null, kids.map(function (k) { return k.offsetTop; }));
      kids.forEach(function (k) { if (k.offsetTop + k.offsetHeight > lastTop) used += Math.max(1, Math.round(k.offsetWidth / colW)); });
      return bottom ? (cols - used % cols) % cols : 0;
    }
    function fill() {
      var grid = root.querySelector('[data-grid]'), more = root.querySelector('[data-more]');
      if (!grid || !more) return;
      var need = missing(grid); if (!need) return;
      page(more.href).then(function (doc) {
        var seen = shown(grid);
        [].filter.call(doc.querySelectorAll('[data-grid] > .mjc-card'), function (c) { return !seen[key(c)]; }).slice(0, need)
          .forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
        count();
      });
    }
    fill();
    var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(fill, 300); });

    function collapse(on) {
      root.querySelector('[data-layout]').classList.toggle('is-collapsed', on);
      var b = root.querySelector('[data-filter-toggle] .mjc-tbtn__d'); if (b) b.textContent = on ? 'Show Filters' : 'Hide Filters';
    }
    function sheet(on) {
      root.querySelector('[data-filters]').classList.toggle('open', on);
      root.querySelector('[data-scrim]').classList.toggle('open', on);
      document.body.classList.toggle('mjdh-lock', on);
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sheet(false); });
    window.addEventListener('popstate', function () { swap(location.href, false); });
  }
  function boot() { document.querySelectorAll('.mjc[data-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
